import React, { FC } from 'react'
import './TransactionNotFound.scss'
import { GoQuestion } from 'react-icons/go'
import { Link } from 'react-router-dom'
import { routingService } from 'app_services/routingService'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'

const TransactionNotFound: FC = () => {
  return (
    <div className="transactions-not-found--big-container">
      <div className='transactions-not-found--container'>
        <div className='transactions-not-found--title'>Transacción no encontrada</div>
        <div className='transactions-not-found--timer-icon-container'>
          <GoQuestion size={150}/>
        </div>
        <div className='transactions-not-found--subtitle'>No ha sido posible encontrar la transacción.</div>
        <Link style={{marginTop: 'auto'}} to={routingService.getSecurePath('?section=certifications')}>
          <ButtonComponent variant='secondary' textTransform='none' width='100%' marginTop='20px'>Volver al sitio</ButtonComponent>
        </Link>
      </div>
    </div>
  )
}

export default TransactionNotFound
